export default {
  hsk_left_time: '考试剩余时间',
  hsk_submit_paper: '提交试卷',
  hsk_rotate_device_title: '请将设备横屏放置',
  hsk_rotate_device_desc: '以获得最佳答题体验',
  hsk_not_finished: '未完成',
  hsk_not_start: '未开始',
  hsk_finished: '已完成',
  hsk_if_test: '您上次考试还未结束，是否继续考试？',
  hsk_progress_lost_restart: '未找到上次的作答记录，本次将从第一题开始',
  hsk_exam_data_error: '考试数据异常，请返回后重试',
  hsk_start_again: '重新考试',
  hsk_go_on: '继续考试',
  hsk_if_save: '确定退出模拟考试吗? 退出后将会保留答题记录，下次进入可继续作答本模块',
  hsk_login_filed: '您的登录信息已失效，我们将不会保留您的答题记录',
  hsk_report: '答题报表',
  hsk_point: '分',
  hsk_qualified_point: '{points}分合格',
  hsk_part1: '第{part}部分',
  hsk_accuracy1: '准确率',
  hsk_test_again: '再考一遍',
  hsk_example: '例',
  hsk_example_eg: '例',
  hsk_answer_analysis: '答案解析：',
  hsk_your_answer: '你的答案：',
  hsk_audio_text: '听力原文：',
  hsk_correct_answer: '正确答案：',
  hsk_listen_name: '听力',
  hskk_listen_name: '设备调试',
  hsk_read_name: '阅读',
  hsk_write_name: '书写',
  hsk_reference_answer: '参考答案：',
  hsk_question_audio_content: '试题音频内容：',
  hsk_reference_answer_hskk: '试题音频内容：',
  hsk_submit_msg: '确定提交试卷吗?',
  hsk_homework_no_answer: '未作答',
  hsk_practice_sava: '确认退出练习吗？退出后当前作答不保留。',
  hsk_practice_go: '去练习',
  hsk_practice_part: '练习模块',
  hsk_practice_operate: '操作',
  hsk_practice_check: '查看',
  hsk_practice_num1: '答对',
  hsk_practice_num2: '题 共 {totalNum} 题',
  hsk_preview_listen_msg: '现在播放试卷说明，在此期间，可以点击答题卡中听力各部分的题号预览试题。',
  hsk_preview_listen_prompt:
    '现在播放试卷说明，在此期间，可以点击答题卡中听力各部分的题号预览试题,考试过程中请不要刷新和关闭页面，否则作答数据将会丢失。',
  hsk_enter_next_segment_msg: '确定进入下一环节吗？',
  hsk_enter_next_segment_preview: '是否结束预览？预览结束后，将开始听力环节的考试。',
  hsk_enter_next_segment_listen_tip: '你有{count}道听力题未作答，',
  hsk_enter_next_segment_listen: '是否提交听力？提交后，听力环节结束。',
  hsk_enter_next_segment_listen_review_start:
    '现在是听力回顾环节，您将拥有{count}分钟检查听力试题的作答情况。',
  hsk_enter_next_segment_listen_review: '是否结束听力回顾，听力回顾结束后，将开始阅读环节的考试。',
  hsk_enter_next_segment_read_tip: '你有{count}道阅读题未作答，',
  hsk_enter_next_segment_read: '是否提交阅读？提交后，阅读环节结束，无法返回进行修改。',
  hsk_enter_next_segment_write_tip: '你有{count}道写作题未作答，',
  hsk_enter_next_segment_write: '确认提交试卷？',
  hsk_end_preview: '结束预览',
  hsk_submit_listen: '提交听力',
  hsk_end_review: '结束回顾',
  hsk_start_exam: '开始考试',
  hsk_start_exam_new: '开始',
  hsk_link_test: '点击进行全真模拟测试',
  hsk_link_tips: '做全真模拟试卷获取官方证书',
  hsk_buy: '购买',
  hsk_test_ready: '考前准备',
  hsk_test_ready_tips: '该试卷包含听力部分，请提前调整好播放设备，听力考试即将开始。',
  hsk_test_content: '考试内容',
  hsk_test_num: '试题数量',
  hsk_total_num: '总题数',
  hsk_test_time: '考试时间',
  hsk_time_total: '时间总计',
  hsk_test_minute: '分钟',
  hsk_about: '约',
  hsk_abbreviation: '我要缩写',
  hsk_determine_ans: '确定开始作答吗？',
  hsk_determine_ans_tips: '开始作答后，无法再次查看原文',
  no_data: '暂无数据',
  hsk_question_number: '题量',
  hsk_test_rate: '考试占比',
  hsk_right_rate: '正确率',
  hsk_operation: '操作',
  hsk_skip: '跳过',
  hsk_spend: '花费',
  hsk_cost: '花费',
  hsk_credit: '余额',
  hsk_pay_successfully: '支付成功',
  hsk_select_amount: '选择充值金额',
  button_common_ok: '确定',
  button_common_cancel: '取消',
  change_lang_ok: '确定',
  change_lang_cancel: '取消',
  hint_player_loader_error: '音频播放失败',
  hint_common_wait_loading: '资源下载中…',
  button_common_hand_in: '提交',
  test_total_question: '共{count}题',
  test_release: '发布',
  test_off_shelf: '下架',
  test_enable: '启用',
  test_record: '模拟考试记录',
  test_finish_time: '完成时间',
  test_paper: '试卷',
  test_confirm_use: '确认启用',
  test_confirm_off_shelf: '确认下架',
  test_has_on_shelf: '已上架',
  test_un_release: '未发布',
  test_un_enable: '未启用',
  test_max_score: '最高分',
  test_average_score: '平均分',
  test_min_score: '最低分',
  test_all: '全部',
  test_has_practiced: '已练习，查看结果',
  test_paper_office: '试卷已下架!',
  test_complete_introduce: '完整介绍',
  test_course_link: '官方课程',
  test_about_down_load: '相关下载',
  test_pay: '支付',
  mark_answer_user: '作答人',
  mark_answer_time: '作答时间',
  mark_correct_time: '批改时间',
  mark_correct_status: '批改状态',
  mark_correct_user: '批改人',
  mark_correct_option: '操作',
  mark_correct_ing: '批改中',
  mark_un_correct: '未批改',
  mark_has_correct: '已批改',
  mark_report_tips:
    '注：书写部分暂未计入总分 {markNumberDesc}题将由专业评分员在48小时内完成批改，批改完成后总分会同步更新，届时我们将会邮件通知你',
  mark_report_tips_hskk:
    '注：试题将由专业评分员在48小时内完成批改，批改完成后总分会同步更新，届时我们将会邮件通知你',
  mark_submit_btn: '提交批改',
  mark_submit_tips: '确认提交批改？',
  mark_back: '返回',
    hsk_answer_sheet: '答题卡',
  mark_correct_tips: '当前试卷正在批改中,不能重复批改！',
  mark_correct_person: '人工批改',
  search_user_message: '搜索用户名',
  mark_current_user: '当前用户',
  mark_correct_paper: '批改',
  mark_all_status: '全部状态',
  mark_all_level: '全部等级',
  mark_overtime: '超时',
  mark_answer: '回答',
  mark_ai_suggest_score: 'Ai建议评分',
  home_test_registration: '考试报名',
  home_word_outline: '词汇检测',
  home_online_practice: '免费样卷',
  home_test: '全真模拟',
  home_page: '首页',
  common_text_control_speed: '播放速度',
  button_common_playback: '播放录音',
  common_text_file_error: '下载资源包失败，请重试',
  common_text_server_error: '再试一次',
  common_text_none_network: '网络不稳定',
  button_common_start_over: '重试',
  evaluating_tips_common: '朗读录音与文本内容相差较大，请重新录音',
  evaluate_common_total_score: '得分',
  evaluate_common_training_remain: '剩余：',
  evaluate_common_training_readyRcord: '准备录音',
  evaluate_common_training_atleast: '录音时长需大于1s',
  evaluate_common_training_atleast2: '录音时长需大于2s',
  evaluate_common_training_evaluting: '评分中',
  evaluating_tips_additionalAndBack: '朗读过程存在增读/回读现象，影响评测总分',
  textbook_chioce_word_text_correct_tip: '回答正确，非常棒！',
  textbook_chioce_word_text_error_tip: '回答错误，再接再厉！',
  textbook_reading_comprehension_stem: '阅读理解',
  spc_back_tips: '确认退出练习吗？ 退出后当前作答不保留',
  spc_level_text: '水平测试',
  spc_capability_assessment: '能力评估',
  spc_pick_level: '选择等级',
  spc_listen: '听',
  spc_speak: '说',
  spc_read: '读',
  spc_write: '写',
  spc_translation: '译',
  spc_result_tips: '经过测试，你的中文能力相当于 HSK level {level}',
  spc_recommend_test: '推荐备考 HSK {level} 级',
  spc_recommend_test1: '推荐备考<strong> HSK {level}</strong> 级',
  spc_again_test: '重新测试',
  spc_where_tips: '不确定我的中文水平？',
  spc_immediate_test: '立即测试',
  spc_test_content: '测试内容',
  spc_test_content_desc:
    '将从听、说、读（朗读）、写（手动输入或选择）、译五个维度去考察学习者的能力，不同等级测试题目不同。',
  spc_test_timer: '测试时间',
  spc_test_timer_desc: '预计15分钟左右，等级越高花费时间越长。',
  spc_test_result: '测试结果',
  spc_test_result_desc: '帮助您快速定级，提升专项技能',
  vocab_level_word: '{level}级词汇',
  vocab_total_item: '共{total}个',
  vocab_search: '搜索汉字/拼音/翻译',
  vocab_all_marked: '全部',
  vocab_already_marked: '已标记',
  vocab_unmarked: '未标记',
  vocabulary: '词语',
  vocab_pinyin: '拼音',
  vocab_translate: '翻译',
  vocab_mark: '标记',
  delete_confirmation: '确认删除词汇',
  cancel: '取消',
  del: '删除',
  edit_vocab: '编辑词汇',
  save: '保存',
  add_vocab: '添加词汇',
  hanzi: '汉字',
  num_bihua: '笔画数',
  write_demo: '书写演示',
  vocab_side: '偏旁部首',
  level: '所在等级',
  see_more: '查看更多',
  same_read_word: '同音字',
  samilar_read_word: '近音字',
  add_mark: '添加标记',
  word_team: '组词',
  instance: '例句',
  include_num_char: '包含{total}个汉字',
  length_diff: '拼音与汉字长度不一致',
  add_word_success: '词汇添加成功',
  add_word_fail: '词汇添加失败',
  edit_word_success: '词汇编辑成功',
  edit_word_fail: '词汇编辑失败',
  del_success: '删除成功',
  del_fail: '删除失败',
  mark_free: '可自由标记，例如标记为“已掌握”',
  write_word_sentence: '请根据上面词语造句…',
  write_word_artical: '请根据上面关键词写短文…',
  write_img_artical: '请根据上面图片写短文…',
  write_artical_title: '请输入文章标题…',
  write_artical_content: '请输入正文内容…',
  my_wallet: '我的购买',
  learn_history: '学习记录',
  manage: '用户管理',
  birthday: '生日',
  email: '邮箱',
  change_pw: '修改密码',
  edit_info: '编辑信息',
  lastName: '姓',
  firstName: '名',
  gender: '性别',
  female: '女',
  male: '男',
  non_disclosure: '不透露',
  change_avatar: '修改头像',
  preview_avatar: '头像预览',
  upload_image: '上传图片',
  change_image: '更换图片',
  enter_old_pw: '请输入旧密码',
  enter_new_pw: '请输入新密码',
  enter_new_pw_again: '请再次输入新密码',
  forget_pw: '忘记密码',
  recharge: '充值',
  left_balance: '可用余额',
  consume_log: '试卷作答',
  recharge_log: '购买记录',
  consume_time: '消费时间',
  consume_source: '消费资源',
  consume_money: '消费金额',
  total_item_log: '共{total}条记录',
  recharge_time: '充值时间',
  recharge_num: '充值数量',
  recharge_money: '充值金额',
  recharge_method: '支付方式',
  learn_content: '学习内容',
  total_score: '总分',
  view_result: '查看成绩',
  management: '用户管理',
  give_history: '赠送历史',
  total_recharge: '总计充值',
  last_login: '最后登录',
  give: '赠送',
  gifted: '赠送',
  give_time: '赠送时间',
  give_to_person: '授予人',
  opera_person: '操作人',
  give_to: '赠送给',
  old_password_empty: '旧密码不能为空',
  diff_password: '两次输入密码不一致',
  change_pw_success: '修改密码成功',
  change_pw_fail: '修改密码失败',
  change_info_success: '修改信息成功',
  change_info_fail: '修改信息失败',
  statistics_center: '统计中心',
  select_recharge_mount: '选择充值金额',
  waiting_pay: '等待支付中...',
  has_no_resolve_credit: '尚未收到付款，请再次尝试购买.',
  complete_pay: '已完成支付',
  pay_fail: '支付失败',
  give_success: '赠送成功',
  give_fail: '赠送失败',
  change_avatar_success: '修改头像成功',
  change_avatar_fail: '修改头像失败',
  enter_family_name: '请输入姓',
  enter_given_name: '请输入名',
  log_in: '登录',
  log_in_error: '登录失败',
  email_address: '邮箱地址',
  invalid_email_address: '非法的邮箱地址',
  password: '密码',
  password_tip: '密码长度6-20位',
  invalid_password: '密码格式错误',
  have_account: '已有{text}账号',
  sign_up: '注册',
  sign_up_error: '注册失败',
  forget_pw_success: '重置密码邮件发送成功',
  forget_pw_error: '重置密码邮件发送失败',
  loading: '加载中',
  account_block: '账号禁用',
  account_block_tip: '请联系你学校的管理员以获取更多信息',
  resend_email: '重新发送邮件',
  resend_email_success: '邮件已重新发送',
  resend_email_error: '重新发送邮件失败',
  i_am: '我是',
  choose_role: '哪一个最能描述你',
  choose_role_error: '选择角色失败',
  continue: '继续',
  learner: '学生',
  learner_description: '我正在学中文',
  teacher: '教师',
  teacher_description: '我正在教中文',
  setup_account_error: '设置账号信息失败',
  tos_link: '服务条款',
  privacy_link: '隐私政策',
  email_verified: '邮箱已验证！',
  email_verified_tip: '感谢验证你的邮箱。',
  email_verified_error: '无法验证你的账号',
  something_wrong: '出问题了',
  retry: '重试',
  guardian_consent_error: '操作失败',
  about_us: '关于我们',
  about_us_new: '关于我们',
  feedback: '联系我们',
  download: '下载',
  submit: '提交',
  feedback_success: '提交成功',
  feedback_error: '提交失败',
  feedback_contact_tip: '提交后，我们会通过您注册使用的邮箱及时与您联系。',
  logout: '退出登录',
  my_account: '我的账号',
  login_signup: '登录 / 注册',
  please_enter_content: '请输入反馈内容（必填)',
  describe_detail: '如果您描述的是问题，请提供尽可能详细的信息',
  upload_picture: '照片上传（可选，最多{maxFiles}张。支持JPG/PNG，单张图片不超过2M)',
  file_error: '文件格式或大小错误',
  file_num_limit: '文件上传数量最多{maxFiles}个',
  sure_change_lang: '确认切换语言？',
  privacy_policy_text1: 'HSK Mock.com——汉考国际唯一认证的模拟考试平台',
  privacy_policy_text2:
    '模拟考试平台由Wo  Hui和汉考国际基于HSK和YCT试题库合作开发和运营。提供完整真题模考训练，为中文学习者的标准化中文考试保驾护航。',
  privacy_policy_text3: 'Wo Hui Mandarin是汉考国际官方合作伙伴。',
  privacy_policy_text4:
    '汉考国际教育科技（北京）有限公司，是专业化国际中文教育考试服务机构，致力于为世界各国（地区）提供国际中文教育和考试研究设计、技术研发、考试实施、市场推广等方面的专业化服务，最大限度满足全球中文学习者和中文教育机构的需求。',
  privacy_policy_text5:
    '我会是由EiM国际教育集团于2018年在新加坡创立的，致力于为全球的中文学习者提供学习中文的技术支持、平台服务的独立公司。为不同的学生提供多样的课程；为教师提供海量教学资源与实用教学工具。科技智能辅助教学，解放教师双手，完善教学过程，帮助学生实现自己的个性化目标，鼓励学生成为卓越的独立学习者。',
  privacy_policy_text6:
    '汉考国际与我会具有良好的合作基础，共同致力于中文学习的推广与发展。为更精准的判断学生的水平，进行针对性学习，模拟真实考试环境，两者进行深度的战略合作，全方位满足中文学习者的学习需求。',
  level_test: '水平测试',
  level_test_example:
    '如果您不确定自己的水平，可以免费参加一次快速测试，看看您适合设置什么水平的学习目标。',
  download_app_mobile: '为了更好的使用体验，请使用桌面版访问hskmock.com或下载APP使用',
  common_video_failed: '音频加载失败',
  member_error: '资源异常！',
  agree_policy:
    '我已阅读并同意<u class="strong"><a href="{url}" target="_blank">《用户协议》</a></u>和<u class="strong"><a href="{userUrl}" target="_blank">《隐私政策》</a></u>',
  please_check: '请勾选阅读并同意《用户协议》和《隐私政策》',
  media_devices_unsupported_browserLabel:
    '建议设置Google Chrome浏览器为默认浏览器。 设置方法： 以Windows10为例：设置-应用-默认应用-网络浏览器-选择Google Chrome',
  media_devices_help_title: '是否开启麦克风',
  media_devices_help_content: '您需要打开麦克风才能录制音频',
  batch_exist_user: '{number} 已注册用户',
  batch_and: '和',
  batch_un_exist_user: '{number} 未注册用户',
  batch_from: '来自',
  batch_notes: '备注',
  batch_something: '请填写',
  batch_people_number: '赠送人数量',
  batch_use_number2: '消耗量',
  batch_operation_status: '操作状态',
  batch_ing_status: '进行中',
  batch_success: '成功',
  batch_failed: '失败',
  batch_select: '请选择',
  common_to: '至',
  common_start_time: '开始日期',
  common_end_time: '结束日期',
  batch_search_tips: '在此处粘贴用户帐号（请用逗号分隔，一次最多可以导入 50 个用户）',
  common_un_exist: '未注册',
  common_invalid: '无效',
  batch_all_give: '批量赠送试卷',
  batch_single_people: '个人',
  batch_all: '批量',
  batch_name: '名称',
  batch_added_credits: '赠送数量',
  batch_spent_credits: '花费数量',
  batch_account_status: '账号状态',
  batch_Added_total: '总计赠送',
  batch_spent_total: '总计花费',
  batch_Remaining: '剩余',
  batch_Recipients: '授予人',
  batch_Active: '已激活',
  batch_search: '搜索',
  certificate_details: '证书详细信息',
  get_official_mock_certificate: '获取官方模拟证书',
  certificate_tips: '证书的详细信息取自您的个人信息。请确认无误:',
  country: '国籍',
  select_country: '请选择国籍',
  email_to: '证书将通过电子邮件发送至：',
  polyphonic: '多音字',
  click_tips: '点击题号查看答案',
  download_tips: '成绩合格即可下载模拟考试证书',
  cancel_delete_account: '注销账号',
  cancel_confirm: '确认',
  user_apply_delete_account_title: '申请注销账号',
  user_apply_delete_account_confirm_tip: '确认您的登录信息',
  user_apply_delete_account_alwaysTip: '您现在要求永久删除您模拟考账号及相关个人数据。',
  user_apply_delete_account_confirm_tip2: '提交申请前，请确认您的身份。',
  user_apply_delete_account_desc:
    '您的账号{email}用于登录并使用于<a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> 及 <a href="{mockLink}" target="_blank">HSK Mock</a>',
  user_apply_delete_account_desc2: '注销后将无法继续使用该账号登录上述应用。',
  user_apply_delete_account_wohui_title: '取消我会订阅',
  user_apply_delete_account_hsk_title: 'HSK MOCK 余额',
  user_apply_delete_account_next_tip: '单击“下一步”按钮，确认您已阅读并同意上述内容。',
  user_apply_delete_account_next_title: '下一步',
  user_apply_delete_account_confirm_tip11: '取消您的订阅后再完成您注销账号的请求',
  cancel_delete_ok: '好的',
  cancel_delete_request_send: '发送请求',
  user_apply_delete_account_confirm_tip8: '当您的订阅于{date}到期时，您的账号将永久删除',
  user_apply_delete_account_confirm_tip4: '我们将发送邮件至',
  user_apply_delete_account_confirm_tip5: '以确认您的账号已被删除',
  user_apply_delete_account_confirm_tip6: '取消您的请求请点击“取消”',
  user_apply_delete_data_always: '您想取消永久删除您的模拟考账号及相关个人数据的请求吗?',
  cancel_delete_yes: '确定',
  cancel_delete_no: '取消',
  user_cancel_delete_success: '我们已经取消您的请求，不会对您的HSK Mock账号进行注销。',
  user_cancel_subscribe_again: '您可以重新进行订阅。',
  user_apply_delete_account_confirm_tip9: '您的订阅截止日期为',
  user_apply_delete_account_confirm_tip10: '请您选择想要注销账号的时间',
  user_apply_delete_account_ok_btn_title: '订阅到期时间',
  user_apply_delete_account_now_btn_title: '立刻注销',
  cancel_out_subscription_abnormal: '用户订阅信息异常',
  user_apply_delete_account_confirm_tip3:
    '您在Apple上有订阅，会自动向您收取费用，请在续订前取消您的Apple订阅',
  user_apply_delete_stripe_tip:
    '您的订阅Stripe会自动通过您的信用卡/借记卡中收取费用 请访问我们的网站',
  user_apply_delete_account_balance: '您的账户余额为',
  user_apply_delete_account_balance_tip: '一旦注销，余额将不会返还.',
  user_apply_delete_account_expire: '您的账号将于三日内注销',
  my_class_name: '我的班级',
  my_class_search: '搜索班级',
  my_class_total: '总计',
  my_class_people: '人',
  my_class_ci: '人次',
  my_class_number: '人数',
  my_class_ci_number: '次数',
  my_class_tips: '内圈：HSK和YCT分布占比',
  my_class_tips1: '外圈：HSK和YCT个等级分布占比',
  my_class_all_class: '全部班级',
  follow_lesson: '查看课程',
  real_paper: '进行全真模拟测试',
  start_answer: '开始作答',
  edit_message_date: '日期',
  edit_message_language: '语言',
  edit_message_zh: '中文',
  edit_message_en: '英文',
  edit_message_title: '标题',
  edit_message_content: '请输入正文',
  edit_message_show: '展示',
  edit_message_save_success: '保存成功!',
  edit_message_create_success: '新增成功!',
  edit_message_edit1: '编辑',
  edit_message_follow_notice: '查看通知',
  edit_message_textarea_tips: '如添加链接，请在连接后添加空格进行区分',
  edit_message_notifications: '编辑通知',
  edit_message_Send_time: '发送时间',
  edit_message_edit_notification: '编辑通知',
  edit_message_add: '新增通知',
  edit_message_from: '起始时间',
  edit_message_to: '终止时间',
  edit_message_new_add: '新增通知',
  currency: '货币选择',
  pay_failed: '页面未加载成功？',
  pay_un_finished: '无法完成付款',
  select_currency_tips: '如果您愿意，您可以从下面的下拉列表中选择不同的货币',
  change_currency_tips: '您可以随时在“我的帐户”下更改您的首选货币。',
  my_homework: '我的作业',
  my_homework_add: '布置作业',
  my_homework_all_classes: '全部班级',
  my_homework_paper: '试卷名称',
  my_homework_sent_to: '发送',
  my_homework_sent_on: '发送时间',
  my_homework_due_on: '截止时间',
  my_homework_submitted_assignees: '提交人数/发送人数',
  my_homework_class_hint: '班级名称周围的图标代表只分配到部分学生',
  my_homework_delay_hint: '显示允许学习者在指定的截止日期和时间后提交作业',
  my_homework_add_send_assignment: '发送作业',
  my_homework_add_new_assignment: '发布作业',
  my_homework_edit_assignment: '编辑任务',
  my_homework_add_assignment: '添加任务',
  my_homework_add_assignment_details: '1. 作业详情',
  my_homework_add_issue_time: '发布时间',
  my_homework_add_whether_submit: '允许在截止时间后提交',
  my_homework_add_note: '备注内容',
  my_homework_add_assignees: '2. 发送对象',
  my_homework_edit_add_assignees: '发送对象',
  // my_homework_add_group: '选择课程',
  my_homework_add_group: '选择班级',
  my_homework_add_immediate_release: '立即发布',
  my_homework_add_time_release: '定时发布',
  my_homework_add_are: '是',
  my_homework_add_no: '否',
  my_homework_detail_back: '返回至我的作业',
  my_homework_detail_sent_to: '发送给',
  my_homework_detail_leamers_in: '位学生在',
  my_homework_detail_on: '在',
  my_homework_detail_to_complete_by: '发送完成在',
  my_homework_detail_add_assignee: '添加发送对象',
  my_homework_detail_assignee: '发送对象',
  my_homework_search_placeholder: '请输入搜索内容',
  my_homework_stu_sent_by: '发送人',
  my_homework_total_topic_count: '共{count}题',
  my_homework_time_full: '{min}分钟',
  my_homework_preview: '预览',
  cookie_consent_title: 'Cookie 使用同意',
  cookie_consent_desc1: '我们使用 Cookie 分析网站使用情况，以改善您的使用体验。',
  cookie_consent_desc2: '点击“接受所有 Cookie”，即表示您同意我们在您的设备上存储 Cookie，以优化网站导航并分析网站使用情况。您也可以点击“全部拒绝”，拒绝非必要 Cookie。',
  cookie_consent_policy_link: '阅读我们的 Cookie 政策。',
  cookie_consent_reject: '全部拒绝',
  cookie_consent_accept: '接受所有 Cookie',
  my_homework_select_date_time: '选择日期时间',
  my_homework_delete_assignment_title: '删除作业',
  my_homework_delete_assignment_tips: '确定删除作业吗，删除后无法取消！',
  my_homework_assignment_add_fail: '发布失败!',
  my_homework_assignment_add_success: '发布成功!',
  my_homework_assignment_edit_success: '编辑成功!',
  my_homework_assignment_edit_fail: '编辑失败!',
  my_homework_assignment_delete_fail: '删除失败!',
  my_homework_assignment_delete_success: '删除成功!',
  my_homework_assignment_due_on: '截止时间',
  my_homework_assignment_product: '商品名称',
  my_homework_assignment_certificate: '证书',
  my_homework_assignment_reset: '重置',
  reset_paper: '试卷重置',
  my_homework_assignment_reset_title: '是否重置所选的模块 ?',
  my_homework_assignment_gifted: '赠送数量',
  my_homework_assignment_papers: '张试卷',
  my_homework_assignment_send_to: '作业发送至',
  my_homework_assignment_close_tip: '当前作业发送还未保存，确认退出吗？',
  pay_callback_tips:
    '如果您在中国大陆，但不是中国公民，我们建议您使用Visa或Master卡。我们正在研究一种解决方案，该解决方案将支持您的微信、支付宝和银联卡。',
  no_available_class: '暂无班级可选择',
  payment_method: '支付方式',
  wechat_pay: '微信支付',
  alipay_payment: '支付宝支付',
  card_payment: '用卡支付',
  card_payment_description: '仅限海外银行卡',
  payment_to_wohui: '向我会我汇我慧科技（上海）有限公司支付',
  order_submitted: '订单提交成功，请尽快付款！',
  order_number: '订单编号：',
  code_expires:
    '距离二维码过期还剩 <span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span>',
  use_weChat: '请使用微信扫一扫，扫描二维码支付',
  code_expired: '当前二维码已失效',
  amount_payable: '应付金额：',
  use_code: '使用兑换码',
  tests: '考试记录',
  level_title: '您的目标等级是什么？',
  level_des:
    '如果不确定，请点击<b style="color: #000;cursor: pointer;font-weight: 700;" class="clickable">免费水平自测 ></b>',
  level_HSK_text1: '<b>HSK</b>是“中文水平考试”的拼音缩写，意思是中文水平测试。',
  level_HSK_text2: '这是全世界最受欢迎的中文水平测试。',
  level_YCT_text1: '<b>YCT</b>  是“中小学生中文水平考试”的英文缩写，',
  level_YCT_text2: '意思是为中小学生提供的中文水平测试。',
  level_PRIMARY: '初级',
  level_BEGINNER: '初级',
  level_INTERMEDIATE: '中级',
  level_ADVANCED: '高级',
  level_dialog_title: '等级测试',
  level_dialog_content:
    '免费水平自测大约需要15分钟，测试结果将显示您目前达到的HSK水平以及您在四项语言技能（听、读、写、说）与该水平的接近程度。',
  level_dialog_login: '登录/注册',
  level_dialog_start: '开始水平测试',
  about_us_first_paragraph:
    '<b>HSK Mock</b>是世界上最受欢迎的中文水平考试HSK和YCT的唯一官方模拟考试平台。该平台是<b>汉考国际</b>和<b>我会中文</b>合作的产品。',
  about_us_second_paragraph:
    '<b>汉考国际</b>（CTI）是HSK和YCT的考试委员会。他们是一家总部位于北京的有限公司，通过为个人和机构提供一系列服务，在全球范围内促进和支持中文作为一门外语的学习、教学和测试。',
  about_us_third_paragraph:
    '<b>我会中文</b>（我会）提供HSK和YCT课程及考试的官方在线平台。他们是一家总部位于新加坡的有限公司，利用技术将学习解放到学生手中，并授权老师在学生的个人学习之旅中提供必要支持。',
  about_us_cti_text: '了解更多：',
  about_us_wohui_text: '如果您想了解更多，请联系：',
  listening_section: '听力部分',
  reading_section: '阅读部分',
  writing_section: '书写部分',
  review_answers: '检查答案',
  characters_long: '如果您还未注册账户，请设置一个6到20个字符的密码。',
  complete_profile: '完成个人资料',
  verify_email: '验证您的电子邮件',
  link_sent: '感谢您的注册。请点击我们发送给您的链接以验证是否为您的正确的电子邮件地址:',
  resend_link: '重新发送链接 >',
  restart: '重新启动',
  parental_consent: '父母知情',
  sent_parental: '感谢您的注册。请按照我们在电子邮件中发送的指示，征得您父母或监护人的同意:',
  thank_you: '感谢！',
  or_return: '或返回程序',
  child_profile: '您小孩的个人资料',
  sign_up_privacy:
    '我已阅读并同意<a class="link" target="_blank" rel="noopener noreferrer" href="{url}">《服务条款》</a>和<a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">《隐私政策》</a>',
  give_consent: '我同意',
  delete_child_details: '删除孩子的信息',
  account_created: '创建账户',
  emailed_know: "我们已经发邮件给<span style='font-weight: 700'>{email}</span>让他们知情。",
  account_deleted: '删除账户',
  child_know_deleted: '请让您的孩子知道他们的详细信息已被删除。',
  request_email:
    '以上信息（邮箱地址除外）在登录后都可更新。请您同意您的孩子创建帐户，否则请要求我们删除他们的详细信息。',
  preferred_currency: '首选货币',
  parent_guardian: '父母/监护人',
  class_name: '班级名',
  // start
  tofficial_platform: 'HSK官方唯一模拟考试平台',
  tofficial_platform_new: 'HSK官方模拟考试平台',
  proficiency_tests: '为世界上最受欢迎的中文水平考试做准备',
  proficiency_tests_new: '集全真试卷、专业评分、词汇强化、智能练习于一体，助力高效备考',
  get_started: '开始使用',
  get_started_new: '开始',
  start_practicing: '开始练习',
  get_ready: '备考HSK，从现在开始！',
  real_hsk_exam_content: '全真试卷',
  real_hsk_exam_desc: '使用全真试卷进行练习，高效备考，自信迎考。',
  official_level_scoring: '专业评分',
  official_level_scoring_desc: '依据HSK官方标准评分，结果权威可靠。',
  vocabulary_boost: '词汇强化',
  vocabulary_boost_desc: '使用免费词汇卡与智能练习工具，轻松记牢每一个词汇！',
  get_hsk_ready: 'HSK备考全攻略',
  how_it_works: '如何使用',
  choose_your_level: '选择等级',
  choose_your_level_desc: '选择适合你的考试等级 —— 从HSK 一级到HSK 九级。',
  practise_and_learn: '学习与测评',
  practise_and_learn_desc: '从免费词汇训练开始！升级账号即可解锁完整HSK官方模拟题和智能评分服务。',
  track_your_progress: '跟踪学习进度',
  track_your_progress_desc: ' 每次测试后查看各部分的分数，持续追踪你的进步，清晰掌握提升方向，高效规划备考时间。',

  got_questions: '有问题？我们有答案',
  faq: '常见问题',
  faq_desc: '有关 HSK 备考和HSK  Mock平台的常见问题。',
  faq_btn: '查看常见问题',

  blog: '博客',
  blog_desc: '浏览我们的博客，了解有关 HSK备考的小技巧。',
  blog_btn: '浏览博客',

  contact: '联系我们',
  contact_desc: '需要个性化的帮助？如有任何问题，请联系我们的客户服务团队。',
  contact_btn: '联系我们',

  mock_tests: '模拟考试',
  blog_and_faq: '博客 & 常见问题',
  real_results_from_real_learners: '真实反馈，真实成果',
  support: '帮助与支持',
  choose_your_hsk_level: '选择你的HSK等级',
  choose_your_hsk_level_desc: '使用官方模拟考试和智能工具备考 HSK、HSK口语和 YCT。',

  hsk_levels: 'HSK',
  hsk_speaking: 'HSK口语',
  yct: 'YCT',
  // hsk3.0
  hsk_levels_tri: 'New HSK',
  hsk_speaking_tri: 'New HSK口语',

  start_learning: '立即开始学习！',
  for_institutions: '学校及各类教育团体',

  for_hsk3_condidates: '适用于HSK 3考生',
  for_hsk4_condidates: '适用于HSK 4考生',
  for_hsk56_condidates: '适用于HSK 5-6考生',
  // end
  platform_china: '本平台也为中国大陆的考生提供帮助。',
  take_confidence: '参加HSK考试胜券在握',
  practice_tests: 'HSK 及 YCT实战演练',
  using_time:
    '使用汉考官方提供的最新真题试卷，熟悉各类题型，掌握考试要求，提升答题速度，顺利完成考试。',
  instant_results: '及时得到反馈',
  each_test_question:
    '逐一回看已完成的每道考题，你能看到得分，还能看到解题详情，也能看到正确答案。了解自己的得失因由，改正错误、明确方向，走向成功。',
  track_progress: '记录进步足迹',
  ready_next_test:
    '平台会自动记录你每次模拟考试的日期和时间，以及每一次技能的提高与成绩变化。这些记录将提示你何时是参加真正考试的最佳时机，届时将取得最佳成绩。',
  receive_official_certificates: '获得官方证书',
  certificates_provide_evidence:
    '为您通过的每一次模拟考试提供证书。这些证书证明您已经具备一定的中文水平。',
  ready_next_level: '开启下一阶段',
  check_description:
    '查看下一关的说明以明确自己的目标。重温考试的要求与规则，复习规定的词汇，预览考试的内容，掌握考试的技巧。',
  on_the_move: '移动端使用？',
  on_the_move_new: '下载HSK Mock APP，',
  download_mobile: '点击以下按钮下载移动端App',
  download_mobile_new: '随时随地备考HSK。',
  footer: 'HSK Mock 是HSK官方模拟考试平台，集全真试卷、专业评分、词汇强化、智能练习于一体，助力高效备考。',
  hsk_beginner_advanced:
    '<span style="font-weight: 700">HSK</span>是“中文水平考试”的拼音缩写，意思是中文水平测试。这是全世界最受欢迎的中文水平测试。从初级到高级一共有9个等级。',
  more: '更多 >',
  more_menu: '了解更多',
  ytc_beginner_advanced:
    "<span style='font-weight: 700'>YCT</span>是“中小学生中文水平考试”的英文缩写，意思是为中小学生提供的中文水平测试。从初级到中级一共有4个等级。",
  coming_end: '2023年底上线口语模考',
  candidates_proficiency_speaking: '这是测试考生说中文的能力。',
  level_oral_tests:
    "<span style='font-weight: 700'>HSKK</span>是“中文水平口语考试”的拼音缩写，意思是中文口语水平测试。",
  check_test_dates: '查看考试日期',
  book_test: '报名考试',
  international_platform:
    '中国平台设在中国大陆内；国际平台设在新加坡。两个平台是彼此独立。请选择适合您的平台。',
  mock_platform: '官方模拟考试平台',
  home_proficiency_tests: '为最受欢迎的中文水平测试做准备',
  currency_type: '货币选择',
  Pick_your_level: '选择您的等级',
  About_this_level: '等级介绍',
  test_session: '次测试',
  Learning_resources: '学习资源',
  Take_practice_test: '模拟考试',
  Compare_syllabuses: '对比大纲',
  table_shows_syllabuses: '该表显示了不同大纲的HSK的水平。',
  forrgin_lang: '0547是“中文作为一门外语”',
  Second_Language: '0523是“中文作为第二语言”',
  Requirement_entry: '注册条件',
  most_Chinese_universities: '大部分中国大学',
  Qing_Hua: '清华大学',
  beijing_university: '北京大学',
  working_towards: '经过测试，推荐你备考',
  On: '在',
  Level_test: '等级测试',
  Retake_level_test: '重考',
  practice_test: '参与一次考试练习',
  Compare_syllabuses_a: '不同课程大纲和HSK大纲对比',
  Not_sure: '不确定自己的水平？',
  free_level_test: '参与免费水平自测',
  Examples: '例题',
  product_code: '产品兑换码',
  enter_paper: '输入兑换码以参与测试',
  no_code: '没有兑换码？请从我们的合作伙伴处购买：',
  to_partner: '转到合作伙伴链接',
  code_here: '请在此输入兑换码',
  start_assigment: '开始',
  view_assigment: '查看结果',
  continue_assigment: '继续',
  choose_method: '选择解锁方式',
  choose_new_method: '请选择解锁新测试的方法。',
  browser_layer: '请在PC上使用Google Chrome浏览器或在移动设备上使用APP',
  partner_title1: '希望您能成为',
  partner_title2: '本地合作伙伴',
  company_name: '公司名称',
  company_website: '公司网站',
  teachers_count: '与您合作的HSK老师的数量',
  learners_count: '与您合作的HSK学生的数量',
  add_msg: '欢迎留言给我们',
  contact_style: '如何联系您?',
  send: '点击发送',
  partner_forms_desc:
    '作为我们的当地合作伙伴，您将成为您所在国家或地区的考生、教师、中小学和大学的主要联系人。<br><br>我们的合作伙伴通常是成熟的HSK考试和培训中心，他们希望扩大业务规模并提升官方认可度。<br><br>如果您想成为我们的当地合作伙伴，请先使用个人HSK模拟账户<span style="color: #faae56; text-decoration-line: underline; cursor: pointer">登录</span>并填写以下信息，我们会尽快和您取得联系。',
  submit_success: '发送成功',
  help_students_for_testing: '您正在帮助学生备考吗？',
  help_students_for_testing_desc:
    '教师在帮助学生达到下一个考试目标方面发挥着至关重要的作用。<br>赋能老师为学生提供个性化学习支持。',
  become_partner: '成为我们的当地合作伙伴',
  become_partner_desc:
    '对考生而言，能够用自己的母语与本地考点联系询问考试详情，且可以选用喜欢的本地支付方式付款。',
  partnership: '探索合作',
  students_forward: '助力您的学生',
  hsk_confidence: '参加HSK考试胜券在握',
  try_it_out: '立即体验',
  walk_through: '熟悉考试流程',
  teachers_page_desc1:
    '平台的功能不但支持班级教学，也适合一对一的教学。让学生熟悉各类题型，复习规定的词汇，预览考试的内容，掌握考试的技巧。',
  assign_practice_papers: '设置学生交卷截止日期和时间',
  teachers_page_desc2:
    '并发布试卷给您的学生。您可以将模拟试卷作为正式考试，帮助学生熟悉HSK考试的不同题型，让他能够在规定的时间内完成各个部分的作答。',
  get_instant_results: '即时反馈成绩',
  teachers_page_desc3:
    '无需教师人工批阅试卷。查看班级学生是否已经完成指定试卷。查看学生每一份试卷的成绩。',
  review_their_answers: '回顾学生作答情况',
  teachers_page_desc4:
    '能够逐个班级、逐个技能、逐个部分甚至逐个问题地深入了解学生的考试成绩。回顾学生的作答情况，您能准确地为学生制定教学方案，提供针对性的反馈。',
  track_prog: '跟踪学生进度',
  teachers_page_desc5:
    '详细记录学生每一次考试的成绩， 并提供试卷每题的答题情况，以及每一次技能的提高与成绩变化。这些记录提示教师，学生何时是参加真正考试的最佳时机，届时将取得最佳成绩。',
  students_next_level: '让学生更上一层楼',
  teachers_page_desc6:
    '我们的姐妹平台提供官方HSK和YCT课程材料，以及您所需要的教学工具和资源，赋能老师为学生提供个性化学习支持。',
  teaching_resources: '教学资源',
  for_teachers: '教师',
  teachers_desc1:
    '请先使用您的个人账号<span style="color: #faae56; text-decoration-line: underline; cursor: pointer">登录</span> HSK Mock模拟考试平台。',
  teachers_desc2: '请在下方填写基本信息，我们将为您的学校开通免费试用。',
  school_name: '学校名称',
  school_web: '学校网站',
  num_of_hsk_teachers: 'HSK教师人数',
  num_of_hsk_learners: 'HSK学生人数',
  hsk_submit_reading: '阅读',
  pay_tip: '如果您以支付宝或微信支付购买模拟试卷，请使用中国大陆服务网页hskmock.cn。',
  use_pc_or_app: '立即体验， 请用电脑登录或下载我们的APP。',
  download_certificate: '下载证书',
  create_certificate: '生成证书',
  certificate_is_downloaded: '证书已下载',
  pay_discount_title: '您想购买多少次{level}的全真模拟考试？',
  total: '总计',
  pay: '支付',
  price_desc:
    '您只需支付全真模拟考试的费用。您如果一次性购买多次全真模拟考试，单次考试即可获得一定折扣。',
  the_level: '等级',
  discounted_price: '价格',
  price_contact_us:
    '我们还为学校和机构提供批量购买的服务。请<span style="color: #faae56; text-decoration-line: underline; cursor: pointer">联系我们</span>讨论您的具体需求。',
  get_a_discount: '获取折扣',
  finished_pay_discount_title: '以下是您{level_name} 全真模拟试卷的兑换码。',
  btn_goto_papers: '查看{level_name}试卷',
  test_count: '{test_num}次测试',
  unit_price: '{price}/次测试',
  buy_code_tip:
    '我们已将这些兑换码通过电子邮件发送给您。现在只需选择您要测试的 {level_name} 试卷，输入兑换码即可解锁。',
  discount_codes_left_tip:
    '测试结束后，您在当前等级将<span style="color: #62C1A5;font-size: 16px;font-weight: 500;">剩余{count}个</span>兑换码。',
  manage_class: '管理班级',
  to_manage_class: '班级管理系统将在新标签页中打开。完成后，请返回此标签页并刷新页面。',
  code_used: '已使用',
  code_can_be_used: '未使用',
  no_test: '数量',
  history_purchase_quantity: '数量',
  hsk_listen_part_title: '听力第{count}部分',
  hsk_read_part_title: '阅读第{count}部分',
  hsk_write_part_title: '书写第{count}部分',
  Description: '介绍',
  Test_format: '考试形式',
  Vocabulary: '词汇',
  vocab_type: '词性',
  sso_login_signup: '登录 / 注册',
  sso_email_address: '邮箱地址',
  sso_password: '密码',
  sso_characters_long: '如果您还未注册账户，请设置一个6到20个字符的密码。',
  sso_forget_pw: '忘记密码',
  sso_agree_policy:
    '我已阅读并同意<u class="strong"><a href="{url}" target="_blank">《用户协议》</a></u>和<u class="strong"><a href="{userUrl}" target="_blank">《隐私政策》</a></u>',
  sso_continue: '继续',
  sso_please_check: '请勾选阅读并同意《用户协议》和《隐私政策》',
  sso_invalid_email_address: '非法的邮箱地址',
  sso_invalid_password: '密码格式错误',
  sso_loading: '加载中',
  sso_mock_platform: '官方模拟考试平台',
  sso_home_proficiency_tests: '为最受欢迎的中文水平测试做准备',
  sso_guardian_consent_error: '操作失败',
  sso_forget_pw_success: '重置密码邮件发送成功',
  sso_forget_pw_error: '重置密码邮件发送失败',
  sso_log_in_error: '登录失败',
  sso_download_app_mobile: '为了更好的使用体验，请使用桌面版访问hskmock.com或下载APP使用',
  sso_no_binding_info_tip: '无法获取您的详细信息',
  sso_third_login_tip: '请选择要打开的网站',
  sso_third_login_wohui: '前往我会中文',
  sso_third_login_mock: '前往HSK模考',
  other_gender: '保密/其他',
  hsk_enter_listening: '听力',
  intro_msg_first: '本次考试共有 {num} 个部分，您必须依次完成。',
  intro_msg_second: '请在规定时间内完成每个部分的试题。',
  intro_msg_third:
    '若您已经完成了本部分的试题但还未到截止时间，您可以进入试卷的下一个部分，但无法再返回到之前的部分继续作答。',
  dialogue_listening: '第一部分是听力考试。 请点击按钮播放下面的测试音频，并根据需要调试您的设备。',
  dialogue_listening_hskk: '请点击按钮播放下面的测试音频，并根据需要调试您的设备。',
  dialogue_intro_msg_first:
    '音乐播放时，会跟着一段考试总体介绍。在播放此介绍时，您可以预览听力部分的试题。',
  dialogue_intro_msg_first_hskk:
    '音乐播放时，会跟着一段考试总体介绍。',
  dialogue_intro_msg_second: '为模拟真实考试，您不能暂停、重放或快进听力部分的音频。',
  dialogue_intro_msg_second_hskk: '为模拟真实考试，您不能暂停、重放或快进。',
  dialogue_intro_msg_third: '听力部分的音频结束后，您将有 {duration} 分钟的时间回顾你的答案。',
  dialogue_intro_question: '遇到问题？',
  dialogue_preload_intro_first: '听力部分的音频正在下载中。',
  dialogue_preload_intro_second: '下载完成后，音频将自动播放，开始测试。',
  dialogue_preload_intro_third: '祝好运！',
  dialogue_preload_title: '考试资源下载中',
  mock_paper_preview: '模拟试卷预览',
  dialogue_mock_paper_intro_title: '考试说明',
  dialogue_mock_paper_intro_sentence1:
    '本次考试约耗时{minutes}分钟。请确保您有足够的时间和电量一次性完成考试。',
  dialogue_mock_paper_intro_sentence2: '本次考试全程在线进行，因此请确保您有稳定的网络连接。',
  dialogue_mock_paper_intro_sentence3:
    '如果您使用的是台式电脑或笔记本电脑，请使用最新版本的 Chrome 或 Safari 网页浏览器。',
  dialogue_mock_paper_intro_sentence4:
    '如果您使用的是平板电脑，请使用我们的移动应用程序而非网页浏览器。若强制后台退出，无法保存考试进度。',
  dialogue_mock_paper_intro_sentence5:
    '考试期间，请勿打开其他浏览器窗口或移动应用程序，请勿切换语言或插/拔其他设备（如U盘、耳机等）。',
  diologue_mock_paper_quit: '退出',
  dialogue_mock_paper_intro_button: '我已阅读并知晓',
  deadline_passed: '截止日期已过',
  mock_skip_introduction: '跳过说明？',
  Listening: '听力',
  Reading: '阅读',
  Writing: '书写',
  personal_info_display_name_as: '证书显示名',
  code_pratice_text: '使用 <span style="font-weight: 600;color: #0C0C0C"> {paper_name} </span> 进行 <span style="font-weight: 600;color: #0C0C0C"> {level_name} </span> 模拟考试',
  code_input_text: '输入一个兑换码:',
  use_code_limit: '每个兑换码限使用一次',
  code_select_text: '或者选择一个兑换码:',
  pay_discounts_desc1: '通过历年考试真题的练习，可以帮助您',
  pay_discounts_desc2: '在您的 [{type}] [{level}] 考试中取得最佳成绩',
  pay_discounts_desc3: '买一赠一',
  pay_discounts_desc4:
    '如果您已经注册了一个正式的 [{type} {level}] 考试，您可以享有“买一赠一”的优惠，购买 [{type} {level}] 模拟试卷',
  pay_discounts_desc5: '您想购买多少份模拟试卷？',
  level_HSKK_text1: 'HSK口语考试考察的是考生的汉语口语能力。它包括初级、中级和高级三个级别。',
  level_HSKK_text2: 'HSK口语考试采用录音的形式进行。',
  level_HSKK_text3: 'HSK3级考生必须通过HSKK初级水平考试，HSK4级考生必须通过HSKK中级水平考试，HSK5级和6级必须通过HSKK高级水平考试',
  test_download_desc: '此等级的模拟试卷正在准备中。同时，请您下载:',
  speaking: '口语',
  Traduction: '翻译',
  my_homework_none_homework: '该等级暂不支持布置模拟考试试卷，敬请期待。',
  my_class_none_test: '该等级暂不支持线上模拟试卷作答，敬请期待。',
  hsk_audio_error: '您当前的网络环境不稳定，音频加载失败，请重试。',
  mock_join_campus_text1: '你是否接受邀请加入这个中文教、学、考社区?',
  mock_join_campus_text2: '加入社区后，教师可以在HSKMock.com上给你布置试卷，或者在app.wohuimandarin.com上布置习题。',
  sso_join_campus_text4: '教师可以查看您的答案，以便能够提供有针对性的反馈。',
  join: '加入',
  free_practice_title: '免费练习',
  choose_free_practice: '选择一种练习方法',
  word_flashcards: '字词抽认卡',
  word_practice: '字词练习',
  analyse_text: '分析文本',
  flashcards_title: '抽认卡',
  practice_exercises_title: '练习习题',
  analyse_title: '分析',
  practice_result_title: '练习结果',
  generate_flashcards: '生成一组抽认卡',
  generate_practice: '生成一组练习题',
  random_select: '随机选择',
  manual_select: '手动选择',
  max_words: '最多 {number} 个词语',
  already_choose: '已选：{total} 个',
  free_practice_words_quantifier: '个',
  // 产品确认错误提示
  free_practice_unchoose_question: '请选择一个问题类型',
  free_practice_unchoose_practice: '请选择一个练习类型',
  none_mark_words_hint: '当前等级你还没有标记过的词语',
  excceed_max_count: '最多可选{total}个词,已达到上限',
  free_practice_sound: '声音',
  free_practice_question: '问题',
  free_practice_choose_exercise: '选择练习类型',
  free_practice_exercise_select: '单项选择',
  free_practice_exercise_Pairs: '配对',
  free_practice_exercise_TF: '选择正/误',
  launch: '开始',
  free_practice_check_text: '你做对了吗?',
  free_practice_timer_pause: '暂停计时',
  free_practice_timer_pause_desc: '若检测到未操作，将自动暂停计时',
  free_practice_seconds: '{number}秒',
  resume: '重新开始',
  flashcard_completed: '完成抽认卡',
  practice_completed: '完成练习',
  practice_spent_minutes: '共计时间: {duration} 分钟',
  practice_result_summary: '结果总结',
  practice_result_progress_txt: '你获得',
  practice_wrong: '错误',
  practice_skip: '跳过',
  practice_done: '完成',
  analyse_desc_1: '根据选定的词汇表分析文本',
  analyse_desc_2: '粘贴或键入中文文本 （最多不超过 {maxCount} 字符）',
  analyse_input_placeholder: '输入中文文本',
  free_practice_need_word: '从表格中选中词汇，或者选择随机生成词汇',
  free_practice_exercise_select_title: '选择正确答案',
  free_practice_exercise_pairs_title: '点击连接匹配',
  free_practice_exercise_meaning_title: '应该译为',
  free_practice_exercise_sound_title: '应该读作',
  free_practice_exercise_characters_title: '应该写成',
  free_practice_show_correct_answers: '展示正确答案',
  free_practice_show_my_answers: '展示我的答案',
  free_practice_check: '检查',
  free_practice_correct: '正确',
  free_practice_characters: '汉字',
   hsk_introduce_objective_questions: '客观题',
  hsk_introduce_subjective_questions: '主观题',
  hsk_input_type_here: '请在此处输入',
  hsk_translation_part_title: '翻译第{count}部分',
  hsk_speaking_part_title: '口语第{count}部分',
  subjective_reading_placeholder: '请根据上面的文章回答问题…',
  // hsk_write_by_artical: '请根据上面的材料写文章…',
  hsk_write_by_artical: '请输入…',
  hsk_translation_by_artical: '请根据上面的材料翻译…',
  hsk_trasnlation_choose_language: '接下来是翻译部分，请选择语种',
  choose_speaker: '选择扬声器',
  choose_microphone: '选择麦克风',
  hsk_is_recording: '正在录音',
  dialogue_speaking: '最后一部分是口语部分。请确保您设备上的扬声器和麦克风正常操作。',
  start_recording: '点击开始录音',
  hsk_write_count: '字数',
  error_access_media: '访问媒体设备时出错。',
  setSinkId_not_supported: '您的浏览器不支持{setSinkId}。',
  error_switch_device: '切换设备时出错。',
  translation_section: '翻译部分',
  speaking_section: '口语部分',
  failed_upload_record: '录音音频上传失败，请点击重新上传。',
  hsk_enter_next_segment_write_high: '是否提交写作？提交后，写作环节结束，无法返回进行修改。',
  hsk_enter_next_segment_translate_tip: '你有{count}道翻译题未作答，',
  hsk_enter_next_segment_translate: '是否提交翻译？提交后，翻译环节结束，无法返回进行修改。',
  hsk_enter_next_segment_speaking_tip: '你有{count}道口语题未作答，',
  Translating: '翻译',
  Speaking: '口语',

  back_to_home: '返回首页',
  about_us_desc:
    '<b>HSK Mock</b> 是官方推出的<b>HSK</b>、<b>HSK 口语</b> 和 <b>YCT</b> 考试在线模拟平台。高度还原真实考试场景，帮助学习者自信备考、精准评估、全面提升。',
  who_we_are: '我们是谁',
  who_we_are_desc:
    'HSK Mock 由 <b>汉考国际 （Chinese Testing International )</b> 与 <b>【我会中文】（Wo Hui Mandarin）</b> 联合打造，致力于为全球中文学习者提供权威、可靠的模拟考试和学习工具。',
  why_choose_hsk_mock: '为什么选择 HSK Mock？',
  about_us_carousel_1: '官方模拟题库',
  about_us_carousel_1_content:
    'HSK Mock 严格遵循并高度还原 HSK、HSK 口语及 YCT 官方考试的题型结构。',
  about_us_carousel_2: '权威评分体系',
  about_us_carousel_2_content:
    'HSK Mock采用与正式考试一致的评分标准，精准评估考生的真实水平。',
  about_us_carousel_3: '高效学习工具',
  about_us_carousel_3_content:
    'HSK Mock还提供各等级专属词汇练习等互动功能，全面提升听、说、读、写各项中文技能。',
  about_us_carousel_4: '多设备灵活使用',
  about_us_carousel_4_content: 'HSK Mock 支持电脑端和手机端，随时随地轻松练习。',
  about_us_carousel_5: '全球学习者的共同选择',
  about_us_carousel_5_content: 'HSK Mock 已服务并助力世界各地的学习者达成其语言学习目标。',

  for_teachers_banner_title: '官方模拟考试平台，适用于学校和全球团队',
  for_teachers_banner_desc: 'HSK官方模拟考试平台集全真试卷、专业评分、词汇强化、智能练习于一体，通过 HSK Mock，可随时随地在线评估中文水平，体验真实的 HSK 和 YCT 考试体验。是国际学校、大学、企业人力资源团队及全球流动管理者的信赖之选。',
  for_teachers_banner_btn: '预约演示',

  for_schools: '针对学校和教育工作者',
  for_schools_desc: '通过官方认可的 HSK 和 YCT 模拟考试，帮助学生自信备考。',
  for_schools_list_1: '与正式考试一致的考试流程，模拟真实考试环境',
  for_schools_list_2: '支持多种设备，随时随地在线测试',
  for_schools_list_3: 'HSK 1-3 级、YCT1-4级即时评分',
  for_schools_list_4: '随时跟进个人及班级的进步情况',

  for_corporates: '针对企业和人力资源团队',
  for_corporates_desc: '灵活快捷的中文评估，满足员工调动、外派、招聘及商业需求。',
  for_corporates_list_1: '外派前语言筛选和内部基准测试',
  for_corporates_list_2: 'HSK 1-3级即时结果；HSK4-6级考试结果 48 小时内提供',
  for_corporates_list_3: '追踪培训后的进步',
  for_corporates_list_4: '随时随地、线上线下进行评估',

  official_format: '官方流程',
  official_format_desc: '模拟真实的 HSK 和 YCT 考试，还原真实考试体验。',
  smart_scoring: '专业评分',
  smart_scoring_desc: '基于官方标准进行评分。',
  progress_analytics: '进度分析',
  progress_analytics_desc: '根据学生或团队的表现进行详细分析与跟踪。',
  remote_access: '远程访问',
  remote_access_desc: '完全基于网络，随时随地使用。',

  why_use_hsk: 'HSK Mock 官方模拟考试平台的适用对象',
  international_schools: '国际学校',
  international_schools_desc: '提供符合 HSK/YCT 标准的中文课程，并具备可扩展的评估能力。',
  universities_institutes: '大学与教职业学校',
  universities_institutes_desc: '为学术中文课程提供官方的测试支持。',
  global_corporates: '全球企业',
  global_corporates_desc: '为面向中国市场的岗位，评估和了解员工的中文水平。',
  language_training_providers: '教育机构',
  language_training_providers_desc: '为学习者提供符合官方标准的模拟考试。',

  ready_to_access: '准备好评估中文水平了吗？',
  book_live_demo: "预约现场演示，开通试用账号，查看成绩分析，快速上手HSK Mock。",
  book_demo: '预约演示',

  institutional_title: '面向教育团体的中文能力评估',
  institutional_desc: 'HSK Mock官方模拟考试平台提供与官方 HSK 和 YCT 考试形式一致的在线中文能力测评，帮助学校、大学及各类教育团体评估学习者的中文水平，并持续跟踪学习进度。',
  institutional_btn: '查看学校/机构解决方案',
  institutional_schools_title: '学校与教育团体',
  institutional_schools_desc: '通过历年HSK考试真题，帮助学生系统备考 HSK 与 YCT 考试。',
  institutional_corp_title: '企业与人力资源团队',
  institutional_corp_desc: '用于招聘、外派或培训项目中的中文能力评估，帮助企业更高效地了解和管理员工的语言能力。',

  real_hsk_exam_content_new: '选择你的HSK等级',
  real_hsk_exam_desc_new: '完成简短的水平测试，获取推荐的 HSK 等级。',
  official_level_scoring_new: '参加 HSK官方模拟考试',
  vocabulary_boost_new: '强化你的词汇',
  vocabulary_boost_desc_new: '我们提供免费的词汇卡和智能练习工具。',

  confidence_card0_detail_desc: '完成简短的水平测试，获取推荐的 HSK 等级。',
  confidence_card0_detail_btn: '免费水平自测',
  confidence_choose_level: '选择等级',
  confidence_card1_detail_btn: '继续',
  confidence_choose_method: '选择一种练习方法',

  // ==================== 新版成绩报告页（newhsk1-6） ====================
  // 只覆盖前端文案。页面上的试卷名、考试结论、话题/语言任务/字词、下一步建议
  // 等内容由接口按 Accept-Language 返回，不在此处。
  //
  // 以下 5 条沿用既有词条，未重复新建：
  //   {points}分合格            → hsk_qualified_point
  //   再考一遍                  → hsk_test_again
  //   试卷已下架!               → test_paper_office
  //   未批改                    → mark_un_correct
  //   成绩合格即可下载模拟考试证书 → download_tips

  // -------- 区块标题 --------
  nr_section_overview: '成绩概览',
  nr_section_overview_aside: '按试卷结构统计',
  nr_section_answer: '答题详情',
  nr_section_answer_aside: '绿色为正确，红色为错误',
  nr_section_analysis: '个人成绩分析',
  nr_section_analysis_desc: '看清本次失分主要来自哪里，以及哪些考试部分表现更好。',
  nr_section_diagnosis: '学习诊断',
  nr_section_next: '下一步学习建议',
  nr_section_next_aside: '结合话题、语言任务、字词与知识掌握生成',

  // -------- 头部 --------
  nr_head_title: '{name} 成绩报告',
  nr_head_result_title: '本次考试结果',
  nr_head_unmarked_wait: '未批改完成，请耐心等待',
  // 空白卷（reportAvailable=false）：一题未答，后端不生成报告内容
  nr_head_no_report:
    '本次考试暂无有效作答记录，因此暂时无法分析你的知识掌握情况和学习表现。建议完成部分题目后再查看成绩分析。',
  nr_head_unmarked_default:
    '书写部分暂未计入总分，将由专业评分员完成批改，批改完成后总分会同步更新，届时我们将会邮件通知你',
  nr_head_loading: '试卷测评正在加载中，请耐心等待...',
  // 轮询超时或连续失败：结果卡改显这句 + 重试按钮，不再无限转圈
  nr_head_loading_timeout: '测评暂时未能生成，请稍后重试',
  // 证书按钮文案沿用既有词条 get_official_mock_certificate（获取官方模拟证书），
  // 与老页保持一致，未重复新建。
  // 未达标时在 download_tips 下面再补一行小字（接口不下发该文案）
  nr_head_cert_hint_fail: '本次未通过，合格后可下载',
  // 价格：接口给 { currency, amount }，在这里拼成展示文案
  nr_price: '{currency}{amount}',

  // -------- 成绩概览 --------
  nr_overview_rate: '本次得分率{n}%',

  // -------- 答题详情 --------
  nr_answer_accuracy: '正确率 {n}%',
  nr_answer_more: '查看全部答题详情（{n}）',

  // -------- 个人成绩分析 --------
  nr_analysis_overall: '整体评价',
  // 整体评价正文。接口只给 overallData 结构化数值，文案在前端按场景选模板：
  //   pass/fail  normal 场景，按是否达标二选一
  //   zero       总分 0 分
  //   full       满分
  // zero / full 场景接口不下发最强/最弱模块（文档明说为 null），所以这两条不含模块名。
  nr_analysis_overall_pass:
    '本次考试总分【{score}】分，【达到 HSK{level} 级】通过标准。【{best}】表现相对较好，【{worst}】是当前需要重点提升的部分，建议优先提升【{worst}】能力，同时保持优势部分。',
  nr_analysis_overall_fail:
    '本次考试总分【{score}】分，【未达到 HSK{level} 级】通过标准。【{best}】表现相对较好，【{worst}】是当前需要重点提升的部分，建议优先提升【{worst}】能力，同时保持优势部分。',
  nr_analysis_overall_zero:
    '本次考试总分【0】分，【未达到 HSK{level} 级】通过标准。各科目目前均需要重点提升，建议先从基础内容开始复习，再逐步进行针对性练习。',
  nr_analysis_overall_full:
    '本次考试总分【{score}】分，【达到 HSK{level} 级】通过标准。各科目表现均较好，暂未发现需要重点提升的部分，建议继续保持当前学习状态。',
  // 等级拿不到时用的兜底：去掉「HSK{level} 级」这段
  nr_analysis_overall_pass_nolevel:
    '本次考试总分【{score}】分，【达到】通过标准。【{best}】表现相对较好，【{worst}】是当前需要重点提升的部分，建议优先提升【{worst}】能力，同时保持优势部分。',
  nr_analysis_overall_fail_nolevel:
    '本次考试总分【{score}】分，【未达到】通过标准。【{best}】表现相对较好，【{worst}】是当前需要重点提升的部分，建议优先提升【{worst}】能力，同时保持优势部分。',
  nr_analysis_loss_title: '本次{n}分失分主要来自',
  nr_analysis_loss_title_plain: '失分主要来自',
  nr_analysis_score: '{n}分',
  nr_analysis_percent: '占{n}%',
  /**
   * 「表现较好 / 主要影响成绩的部分」两个列表的行名：科目 + 第N部分。
   *
   * 用 nr_subject_* 而不是复用 nr_seg_*：同一个 segmentCode 在页面上有两种叫法
   * —— 答题详情叫「书写」（nr_seg_write），这里叫「写作」，UI 稿本身就是这样。
   * 两套分开放，改一处不会波及另一处。
   *
   * 序数词整条入词条而不是「第{n}部分」拼数字：中文是「第一部分」，
   * 英文是「Part 1」，序数规则各语言不同，交给翻译整条给。
   */
  nr_subject_listen: '听力',
  nr_subject_read: '阅读',
  nr_subject_write: '写作',
  nr_subject_translation: '翻译',
  nr_subject_speaking: '口语',
  nr_part_ordinal_1: '第一部分',
  nr_part_ordinal_2: '第二部分',
  nr_part_ordinal_3: '第三部分',
  nr_part_ordinal_4: '第四部分',
  nr_part_ordinal_5: '第五部分',
  // 中文两段直接相连，英文等语言需要空格，所以留给词条决定
  nr_analysis_row_name: '{subject}{part}',

  nr_analysis_strength: '表现较好的部分',
  nr_analysis_strength_tag: '本次优势',
  nr_analysis_weakness: '主要影响成绩的部分',
  nr_analysis_weakness_tag: '优先关注',

  // -------- 学习诊断 --------
  nr_diag_summary_title: '本次学习表现概览',
  /**
   * 概览标签 = 接口下发的裸名（「基础信息」）+ 这三句固定后缀。
   *
   * 整句入词条、用 {name} 占位，而不是在代码里拿字符串相加：各语言的语序不同 ——
   * 英译回来就是 "{name}: Good performance" 这种冒号式，法译还在冒号前带空格。
   * 相加只会拼出 "Basic InfoGood performance"。
   *
   * weakTags 与 weakGrammarTags 共用 _weak —— 两者后缀文案完全相同，
   * 拆开只会让翻译方对同一句话给出两份不一致的译文。
   */
  nr_diag_summary_tag_good: '{name}本次表现较好',
  nr_diag_summary_tag_weak: '{name}需要加强',
  nr_diag_summary_tag_words: '{name}建议重点巩固',
  nr_diag_topics_title: '话题掌握',
  nr_diag_topics_aside: '按能力表现区间与正确率划分',
  nr_diag_topics_more: '查看更多话题（{n}）',
  // 语法点掌握：按听力 / 阅读 / 写作分项，一个分项一张卡。
  // 分项名复用 nr_subject_*（「写作」），不是答题详情的 nr_seg_*（「书写」），
  // 所以这里没有分项名词条
  nr_diag_grammars_title: '语法点掌握',
  nr_diag_grammars_aside: '分析你在听力、阅读中的语法答题表现，以及写作中的语法使用情况',
  // 分项头右侧的固定标签，它下面那句总结是接口成文下发的（summary 字段）
  nr_diag_grammar_summary_label: '本次表现总结',
  nr_diag_col_grammar: '语法点',
  nr_diag_grammars_more: '查看更多语法点（{n}）',
  nr_diag_tasks_title: '语言任务掌握',
  nr_diag_tasks_aside: '已按你在本次考试交流任务的完成情况',
  nr_diag_tasks_more: '查看更多任务（{n}）',
  nr_diag_col_task: '语言任务',
  nr_diag_col_count: '相关题量',
  nr_diag_col_accuracy: '正确率',
  nr_diag_col_verdict: '本次表现',
  nr_diag_words_title: '本次未稳定掌握的字词',
  nr_diag_words_total: '共{n}个字词',
  // 字词卡右上角的 tag：接口给 unstableWords[].wrongCnt，这句是前端固定文案
  nr_diag_word_wrong_count: '关联错题{n}题',
  // ⚠️ 已停用（字词卡右上角改成了上面那句带错题数的）。
  // 12 种语言都还留着译文，暂不删 —— 万一产品改回固定文案还能直接用
  nr_diag_word_tag: '未稳定掌握',
  nr_diag_words_more: '查看更多字词（{n}）',
  nr_diag_stats_title: '本次字词统计',
  nr_diag_stat_involved: '涉及字词',
  nr_diag_stat_unstable: '未稳定掌握',
  nr_diag_stat_accuracy: '字词正确率',
  // 三项数值下方的说明。接口的 wordSummary 只给数值不给文案，由前端按模板拼
  nr_diag_stat_involved_note: '本次考试共涉及{n}个字词',
  nr_diag_stat_unstable_note: '共有{n}个字词在本次考试中出现重点失分',
  nr_diag_stat_accuracy_note: '根据本次考试涉及字词统计计算',
  // 整张统计卡底部的口径说明，避免用户误以为是该等级全部字词的掌握度
  nr_diag_stats_footnote:
    '以上统计仅基于本次考试涉及的字词生成，不代表用户对该等级全部字词的整体掌握情况。',
  // 「本次表现」列的 tag 文案不在这里定义 —— 直接用接口下发的
  // diagnosis.tasks[].masteryDesc，前端只按 performance 配色
  nr_diag_question_count: '{n}题',
  // 话题卡底部右侧：答对题量（左侧的总题量复用 nr_diag_question_count）
  nr_diag_question_correct: '答对{n}题',
  nr_diag_question_total: '共{n}小题',

  // -------- 付费提示条 --------
  nr_banner_free_title: '学习诊断报告限时免费开放',
  nr_banner_free_desc: '当前可免费查看完整成绩分析、学习诊断与下一步学习建议',
  nr_banner_owned_title: '完整学习诊断已解锁',
  nr_banner_owned_desc: '可查看完整成绩分析、学习诊断与下一步学习建议',
  nr_banner_paywall_title: '完整学习诊断为付费内容',
  nr_banner_paywall_desc: '免费查看考试结果与答题详情，解锁后查看完整分析和学习建议',

  // -------- 解锁卡 --------
  nr_unlock_tag: '完整报告待解锁',
  nr_unlock_title: '解锁完整成绩分析与学习诊断',
  nr_unlock_desc: '查看详细失分来源、话题掌握、语言任务、字词与知识掌握，以及下一步学习建议。',
  nr_unlock_btn: '{price} 解锁完整报告',
  nr_unlock_btn_plain: '解锁完整报告',
  nr_unlock_footnote: '购买后可查看本次完整报告',

  // -------- 通用 --------
  nr_common_retry: '重试',
  nr_common_collapse: '收起',

  // ⚠️⚠️ 以下 nr_seg_* 与 nr_qtype_* 共 52 条是**动态拼接 key**，
  // 代码里写作 $t('nr_seg_' + code) / $t('nr_qtype_' + questionType)，
  // 全文搜索这些 key 的字面量会一条都搜不到。
  //
  // **不要用"清理未使用词条"这类自动化工具处理它们** —— 会被全部误删，
  // 后果是成绩概览的模块名、答题详情的部分标题、成绩分析的题型名
  // 集体变成空白（取不到词条时回落空串，不报错、不留痕迹）。
  // 送翻译时同理：这 52 条都要翻，不能因为"代码里搜不到"就跳过。

  // -------- 模块名 --------
  // 接口只下发 segmentCode，模块名由前端本地化（后端接口文档 §2.1 answerOverview 注）
  nr_seg_listen: '听力',
  nr_seg_read: '阅读',
  nr_seg_write: '书写',
  nr_seg_translation: '翻译',
  nr_seg_speaking: '口语',
  // 「听力 · 第1部分」的部分名
  nr_part_name: '第{n}部分',
  nr_seg_part: '{seg} · {part}',

  // -------- 题型名 --------
  // key = 归一化后的 questionType，格式 {级别}_{模块}_{部分号}，前缀 nr_qtype_ 。
  // 接口实测下发 new_hsk2_listen_1（无题型码），而最初的题型对照表是
  // new_hsk2_listen_xp_1（带资源包题型码）。两种形态由 mixins/localizedName.js
  // 的 nrNormalizeQuestionType 归一到同一个 key，所以只需这一套词条。
  // 归一化后原表里少数键会重合（如 new_hsk3_listen 的 xw_3 与 lt_3），
  // 但它们的名称本来就相同，不产生歧义。
  nr_qtype_new_hsk1_listen_1: '听力图片选择',
  nr_qtype_new_hsk1_listen_2: '听力文字选择',
  nr_qtype_new_hsk1_listen_3: '听力图片匹配',
  nr_qtype_new_hsk1_listen_4: '听力理解',
  nr_qtype_new_hsk1_read_1: '句图匹配',
  nr_qtype_new_hsk1_read_2: '信息匹配',
  nr_qtype_new_hsk1_read_3: '选词填空',
  nr_qtype_new_hsk1_read_4: '阅读理解',
  nr_qtype_new_hsk2_listen_1: '听力图片选择',
  nr_qtype_new_hsk2_listen_2: '听力图片匹配',
  nr_qtype_new_hsk2_listen_3: '听力理解',
  nr_qtype_new_hsk2_read_1: '句图匹配',
  nr_qtype_new_hsk2_read_2: '选词填空',
  nr_qtype_new_hsk2_read_3: '信息匹配',
  nr_qtype_new_hsk2_read_4: '阅读理解',
  nr_qtype_new_hsk2_write_1: '汉字部件选择',
  nr_qtype_new_hsk2_write_2: '看拼音写汉字',
  nr_qtype_new_hsk3_listen_1: '听力图片匹配',
  nr_qtype_new_hsk3_listen_2: '听力理解',
  nr_qtype_new_hsk3_listen_3: '听力理解',
  nr_qtype_new_hsk3_read_1: '信息匹配',
  nr_qtype_new_hsk3_read_2: '选词填空',
  nr_qtype_new_hsk3_read_3: '阅读理解',
  nr_qtype_new_hsk3_write_1: '看拼音写汉字',
  nr_qtype_new_hsk3_write_2: '看图用词造句',
  nr_qtype_new_hsk4_listen_1: '听力理解',
  nr_qtype_new_hsk4_listen_2: '听力理解',
  nr_qtype_new_hsk4_read_1: '选词填空',
  nr_qtype_new_hsk4_read_2: '阅读理解',
  nr_qtype_new_hsk4_read_3: '选句填空',
  nr_qtype_new_hsk4_write_1: '看图用词造句',
  nr_qtype_new_hsk4_write_2: '短文写作',
  nr_qtype_new_hsk5_listen_1: '听力理解',
  nr_qtype_new_hsk5_listen_2: '听力理解',
  nr_qtype_new_hsk5_read_1: '选词填空',
  nr_qtype_new_hsk5_read_2: '段落排序',
  nr_qtype_new_hsk5_read_3: '阅读理解',
  nr_qtype_new_hsk5_write_1: '连环图写作',
  nr_qtype_new_hsk5_write_2: '话题作文',
  nr_qtype_new_hsk6_listen_1: '听力内容一致选择',
  nr_qtype_new_hsk6_listen_2: '听力理解',
  nr_qtype_new_hsk6_listen_3: '听力理解',
  nr_qtype_new_hsk6_read_1: '选词填空',
  nr_qtype_new_hsk6_read_2: '选句填空',
  nr_qtype_new_hsk6_read_3: '阅读理解',
  nr_qtype_new_hsk6_write_1: '应用文写作',
  nr_qtype_new_hsk6_write_2: '话题作文',
  // 用于「表现较好的部分 / 主要影响成绩的部分」两个列表。
  // 接口给了表外的新题型时前端回落显示所属模块名，不显示裸 key。

  // -------- 下一步学习建议 --------
  // 正文现在优先用后端成文：满分卷取 *Title/*Text 直出，非满分卷取 *Text /
  // weakestGrammars[].text（见 newHskReport/model.js 的 buildNextSteps）。
  // 下面四条模板只做**存量报告**（v0.2/v0.3 早期落库、没有成文字段）的回退，
  // 用结构化数据（name/totalCnt/wrongCnt/correctRate）插值拼出来，别删。
  // 四种卡分别对应 weakestTopic / weakestTask / focusWords / weakestGrammars。
  nr_next_topic_text:
    '本次“{name}”相关题目共 {total} 题，答错 {wrong} 题，正确率为 {rate}%，建议加强该话题相关内容的学习。',
  nr_next_task_text:
    '本次“{name}”相关题目共 {total} 题，答错 {wrong} 题，正确率为 {rate}%，建议通过相关题目继续练习。',
  nr_next_words_text: '“{words}”等字词在本次考试中出现失分，建议优先复习相关词义、用法及使用场景。',
  /**
   * 语法点卡。{total} 用的是接口的 answeredCnt 而不是 totalCnt ——
   * 正确率的分母只数已作答，拿总题数会拼出「共 5 题，答错 3 题，正确率 25%」
   * 这种三个数字对不上账的句子（接口文档在该字段上专门警告过）。
   * {content} 是语法点下的具体内容（「上、下、前、后」），是中文语法材料本身，接口不翻译。
   */
  nr_next_grammar_text:
    '本次“{name}”相关题目共 {total} 题，答错 {wrong} 题，正确率为 {rate}%，建议加强“{content}”的基本用法，并结合相关例句进行练习。',
  // 字词卡标题：把 focusWords 的词用顿号连接
  nr_next_words_separator: '、',

  // -------- 错误提示 --------
  nr_err_load_failed: '成绩报告加载失败，请稍后重试',
  nr_err_scene_unsupported: '该考试类型暂不支持查看新版成绩报告',
  nr_err_level_mismatch: '该成绩报告不适用于当前试卷类型',
  nr_err_no_credit: '本次模考次数已用完',
  nr_err_retake_network: '网络异常，请重试',
  nr_err_retake_failed: '暂时无法开始考试，请稍后重试',
  nr_err_question_not_found: '题目数据异常，请重新下载试卷',
  nr_err_view_question_failed: '暂时无法查看该题，请稍后重试',
  nr_err_common: '操作失败，请稍后重试',
  // 支付
  nr_err_pay_failed: '支付发起失败，请稍后重试',
  nr_err_pay_closed: '订单已关闭，请重新发起支付',
  nr_err_pay_timeout: '支付结果确认中，若已完成支付请刷新页面查看',
  // 以下为首页改版（2026-09 原型）新增词条，暂用英文占位，待翻译后替换
  home_v2_hero_kicker: 'Official Online HSK Mock Test Platform',
  home_v2_hero_title_1: 'Take an Official',
  home_v2_hero_title_2: 'HSK Mock Test Online',
  home_v2_hero_desc: 'Test your Chinese proficiency with real HSK exam questions, real test timing and HSK aligned scoring.',
  home_v2_hero_image_alt: 'HSK Mock platform displayed on a desktop computer in a warm modern home office',
  home_v2_choose_your_exam: 'Choose Your Exam',
  home_v2_proof_cti_title: 'Developed with Chinese Testing International',
  home_v2_proof_cti_desc: 'The organisation behind the HSK exam.',
  home_v2_proof_learners_title: 'Learners worldwide',
  home_v2_proof_learners_desc: 'Preparing for HSK with HSK Mock.',
  home_v2_proof_authentic_title: 'Authentic past exam content',
  home_v2_proof_authentic_desc: 'Real question types, structure and scoring.',
  home_v2_ai_badge: 'New',
  home_v2_ai_title: 'See Where You Can Improve Before Test Day',
  home_v2_ai_desc: 'The AI Score Report turns your New HSK mock test into clear insights you can use for your next study session.',
  home_v2_ai_slide1_a: 'Score',
  home_v2_ai_slide1_b: 'Overview',
  home_v2_ai_slide2_a: 'Topic, Grammar,',
  home_v2_ai_slide2_b: 'Language Task Mastery',
  home_v2_ai_slide3_a: 'Words, Characters',
  home_v2_ai_slide3_b: 'to Review',
  home_v2_ai_slide4_a: 'Next Study',
  home_v2_ai_slide4_b: 'Recommendations',
  home_v2_ai_cta: 'Explore New HSK Mock Tests',
  home_v2_ai_note: 'Only available with New HSK mock tests.',
  home_v2_testimonials_title: 'What Learners Achieved with HSK Mock',
  home_v2_testimonials_desc: 'Real preparation experiences and measurable exam results.',
  home_v2_experience_title: 'Practise the HSK Online',
  home_v2_exp1_a: 'Real Test',
  home_v2_exp1_b: 'Interface',
  home_v2_exp1_desc: 'Take a full mock test with real HSK structure, timing and authentic past exam content.',
  home_v2_exp1_alt: 'HSK Mock real test interface',
  home_v2_exp2_a: 'HSK Aligned',
  home_v2_exp2_b: 'Scoring',
  home_v2_exp2_desc: 'See your result clearly after the test, with scoring aligned to HSK standards.',
  home_v2_exp2_alt: 'HSK Mock scoring results',
  home_v2_exp3_a: 'Improve Your',
  home_v2_exp3_b: 'Vocabulary',
  home_v2_exp3_desc: 'Review the words and characters that need more attention before your next attempt.',
  home_v2_exp3_alt: 'HSK Mock vocabulary review',
  home_v2_b2b_title: 'HSK Mock for Schools and Institutions',
  home_v2_b2b_lead: 'Give your learners HSK and YCT mock tests online. Review completion and scores in one place, and see where more preparation is needed.',
  home_v2_b2b_point1: 'Choose tests by exam and level',
  home_v2_b2b_point2: 'See completion and scores',
  home_v2_b2b_point3: 'Spot where learners need more practice',
  home_v2_b2b_cta: 'Talk to Our Education Team',
  home_v2_b2b_image_alt: 'Students taking HSK Mock tests online in a classroom',
  home_v2_app_label: 'HSK Mock mobile app',
  home_v2_app_title: 'Continue Your Preparation Wherever You Study',
  home_v2_app_desc: 'Switch between desktop and mobile with the same account to take mock tests and review your results wherever you study.',
  home_v2_app_store_pre: 'Download on the',
  home_v2_app_store_aria: 'Download HSK Mock on the App Store',
  home_v2_google_play_pre: 'Get it on',
  home_v2_google_play_aria: 'Get HSK Mock on Google Play',
  home_v2_app_learner_alt: 'Learner preparing for HSK on a laptop',
  home_v2_app_phone_alt: 'HSK Mock mobile app shown on a phone',
  home_v2_help_title: 'Need Help?',
  home_v2_help_faq: 'FAQ',
  home_v2_help_faq_desc: 'Find answers to the most common questions about HSK preparation and our platform.',
  home_v2_help_faq_link: 'Browse FAQs',
  home_v2_help_contact: 'Contact',
  home_v2_help_contact_desc: 'Need personalised help? Get in touch with our support team for any questions or concerns.',
  home_v2_help_contact_link: 'Contact Us',
  home_v2_help_bubble: 'Need help?',
  home_v2_help_mascot_alt: 'HSK Mock panda mascot',
  // 以下为等级选择页改版（2026-09 原型）新增词条，暂用英文占位，待翻译后替换
  choose_v2_intro: 'Select the exam you are preparing for, then choose your level.',
  choose_v2_back: 'Back to homepage',
  choose_v2_select_exam: 'Select Exam',
  choose_v2_choose_level: 'Choose Level',
  choose_v2_level_help: 'Not sure which level to choose?',
  choose_v2_level_help_link: 'Try the free level test',
  choose_v2_fact_questions: '{n} questions',
  choose_v2_fact_minutes: '{n} minutes',
  choose_v2_fact_minutes_about: 'About {n} minutes',
  choose_v2_fact_full_speaking: 'Complete speaking test',
  choose_v2_result_immediate: 'Results available immediately',
  choose_v2_result_48h: 'Results within 48 hours',
  choose_v2_result_before_purchase: 'Result timing shown before purchase',
  // 以下为等级详情页改版（2026-09 原型）新增词条，暂用英文占位，待翻译后替换
  product_v2_back: 'Change exam or level',
  product_v2_badge_aria: 'Selected exam',
  product_v2_tabs_aria: 'Level navigation',
  product_v2_tab_tests: 'Tests',
  product_v2_tab_about: 'About',
  product_v2_tab_vocabulary: 'Vocabulary',
  product_v2_tab_free: 'Free Practice',
  product_v2_tab_resources: 'Resources',
  product_v2_tests_heading: '{level} Mock Tests',
  product_v2_single_price_aria: 'Price for one HSK Mock test',
  product_v2_single_test: 'Single test',
  product_v2_price_before_payment: 'Price shown before payment',
  product_v2_tests_guidance: 'Choose an HSK Mock test.',
  product_v2_status_ready: 'Ready',
  product_v2_status_progress: 'In progress',
  product_v2_status_complete: 'Completed',
  product_v2_use_code: 'Use a code',
  product_v2_bundle_heading: 'Save with Multi-Test Packs',
  product_v2_pack_tests: 'test | tests',
  product_v2_pack_saving: 'Save {n}',
  product_v2_pack_continue: 'Continue · {price}',
  product_v2_go_title_1: 'A little Chinese.',
  product_v2_go_title_2: 'Every day.',
  product_v2_go_desc_1: 'Learn at your level with HSK 1–3 courses.',
  product_v2_go_desc_2: 'Get official HSK 1 or 2 certification in the app.',
  product_v2_go_apple_aria: 'Download HSK GO on the App Store (opens in a new tab)',
  product_v2_go_google_aria: 'Get HSK GO on Google Play (opens in a new tab)',
  product_v2_go_site_aria: 'Visit the HSK GO website (opens in a new tab)',
  product_v2_auth_purchase_title: 'Continue to buy this test',
  product_v2_auth_purchase_intro: 'Your HSK Mock test will be added to the account you choose after payment.',
  product_v2_auth_purchase_login: 'Log in, review the order and continue to payment.',
  product_v2_auth_purchase_signup: 'Create and verify an account before payment.',
  product_v2_auth_redeem_title: 'Sign in to use your test code',
  product_v2_auth_redeem_intro: 'Your code will add this HSK Mock test to the account you choose.',
  product_v2_auth_redeem_login: 'Log in and add the test to your account.',
  product_v2_auth_redeem_signup: 'Create and verify an account, then add the test.',
  product_v2_auth_have_account: 'Already have an account?',
  product_v2_auth_new: 'New to HSK Mock?',
  product_v2_auth_login: 'Log In',
  product_v2_auth_signup: 'Create Account',
}
